/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const ambulance_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8.25 9.75a1.5 1.5 0 0 1 1.5-1.5H12m-3.75 1.5H4.921a1.5 1.5 0 0 0-1.455 1.136L3 13.5c-.835.557-2.248 1.122-2.25 2.3v4.45a1.5 1.5 0 0 0 1.5 1.5h3.128m2.872-12v9.128M15.75 12v2.25m0 2.25v-2.25m0 0H13.5m2.25 0H18m-3.75-12V.75m3.75 3 .75-1.5m-8.25 1.5-.75-1.5m-4.372 19.5a2.25 2.25 0 0 0 4.244 0m-4.244 0c-.617-1.747 1.175-3.472 2.872-2.872m0 0c1.156.409 1.777 1.726 1.372 2.872m0 0h7.006m0 0a2.251 2.251 0 0 0 4.244 0m-4.244 0c-.502-1.422.59-3 2.122-3a2.25 2.25 0 0 1 2.122 3m0 0h.878a1.5 1.5 0 0 0 1.5-1.5V9.75a1.5 1.5 0 0 0-1.5-1.5H16.5m-4.5 0V7.5a2.25 2.25 0 0 1 4.5 0v.75m-4.5 0h4.5"
    />
  </svg>
)
export default ambulance_medium
